package com.essntl.core.gpt.di

import com.essntl.core.gpt.data.OpenAIClientImpl
import com.essntl.core.gpt.domain.OpenAIClient
import org.koin.dsl.module

val gptModule
    get() =
        module {
            single<OpenAIClient> { OpenAIClientImpl() }
        }
